/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get */
import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { effortLabelFor } from '@linc-technologies/linced-common/utils/effort-labels';

/**
 * Resolves a numeric effort string to its display label.
 *
 * Usage (live): {{reporting/effort-label studentSection.effort}}
 * Usage (snapshot-first): {{reporting/effort-label studentSection.effort snapshotLabel}}
 *
 * When `snapshotLabel` is non-empty it is returned verbatim — this is the
 * publish-snapshot path where the backend has already resolved the label
 * against the school's jurisdiction at publish time. Falls back to live
 * jurisdiction-based resolution otherwise.
 */
export default class EffortLabel extends Helper {
  @service
  session;

  compute([effortValue, snapshotLabel]) {
    if (snapshotLabel) return snapshotLabel;
    let jurisdiction = this.get('session.school.jurisdiction');
    return effortLabelFor(effortValue, jurisdiction);
  }
}
